import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
  override itemsPerPageLabel = 'Éléments par page';
  override nextPageLabel = 'Suivant';
  override previousPageLabel = 'Précédent';
  override firstPageLabel = 'Première page';
  override lastPageLabel = 'Dernière page';

  private rangeLabel = 'sur';

  constructor() {
    super();
    this.getRangeLabel = this.calculateRangeLabel;
  }

  /**
   * Calculates the range label for the paginator.
   * @param page The current page.
   * @param pageSize The number of items per page. Negative values are treated as zero.
   * @param length The total number of items.
   * @returns A string representing the current range.
   */
  calculateRangeLabel(page: number, pageSize: number, length: number): string {
    // Treat negative pageSize as zero
    pageSize = Math.max(pageSize, 0);

    if (length === 0 || pageSize === 0) {
      return `0 ${this.rangeLabel} ${length}`;
    }

    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    // Calculating the end index
    const endIndex = startIndex < length
      ? Math.min(startIndex + pageSize, length)
      : startIndex + pageSize;

    return `${endIndex} ${this.rangeLabel} ${length}`;
  }
}
